import React, { useRef, useState } from "react";
import EventRow from "../EventRow/EventRow";
import { NoteOutlined } from "@toddle-edu/ds-icons";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
} from "../../modules/Utils";
import { connect } from "react-redux";
import { TextAreaInput } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import classes from "./Description.scss";
import _ from "lodash";

const Description = props => {
  const { eventModalV2, updateEventModalV2, testId } = props;
  const [description, setDescription] = useState(eventModalV2?.description);
  const { t } = useI18n(["calendar"]);
  const setEventDescription = setValue("description", updateEventModalV2);
  const debouncedSetEventDescription = useRef(
    _.debounce(value => {
      setEventDescription(value);
    }, 300)
  );
  const eventDescriptionHandler = e => {
    const description = e.target.value;
    setDescription(description);
    debouncedSetEventDescription.current(description);
  };
  const onBlur = () => {
    setEventDescription(description);
  };

  return (
    <EventRow
      className={classes.container}
      labelClass={classes.label}
      label="common:description"
      icon={<NoteOutlined variant="subtle" />}
      renderComponent={() => (
        <div className={classes.textAreaContainer}>
          <TextAreaInput
            onBlur={onBlur}
            placeholder={t("calendar:add_event_description")}
            onChange={eventDescriptionHandler}
            value={description}
            defaultValue={eventModalV2?.description || ""}
            minRows={4}
            type="plain"
            size="medium"
            classNames={classes.description}
            testId={`${testId}-description`}
          />
        </div>
      )}
    />
  );
};

export default connect(mapStateToProps, mapActionCreators)(Description);
